// Object containing constants
define(function(require) {
	return {
		DATE_TIME_MIN_VAL: '0001-01-01T00:00:00',
		DATE_DEFAULT_VAL: '1/1/0001',
		SORT_ASC: 'asc',
		SORT_DESC: 'desc',
		MY_ASSN_MAP: 1,
		MY_PROJ_MAP: 2,
		INSTR_LIST_MAP: 3,
		ADD_SITE_MAP: 4,
		CRM_NEW_LOCATION_MAP: 5,
		CDR_NEW_LOCATION_MAP: 6,
		MY_TSK_MAP: 7,
		ADDRESS : 0b0001,
		PARCEL : 0b0010,
		PROPERTY : 0b0100,//not used
		ASSET : 0b1000,
		APPLICANT_TYPES:function(){
			return {
				building:[
					{},
					{
						code:1,
						description:i18n.t('CIVICS.CONSTANTS.PROPERTY_OWNER')
					},
					{
						code:2,
						description:i18n.t('CIVICS.CONSTANTS.LICENSED_CONTACT')
					},
					{},
					{
						code:4,
						description:i18n.t('CIVICS.CONSTANTS.OTHER_CONTACT')
					}
				],
				businesslicense:[
					{},
					{
						code:1,
						description:i18n.t('CIVICS.CONSTANTS.OTHER_CONTACT')
					},
					{
						code:2,
						description:i18n.t('CIVICS.CONSTANTS.LICENSED_CONTACT')
					},
					{
						code:3,
						description:i18n.t('CIVICS.CONSTANTS.PROPERTY_OWNER')
					}

				],
				codeenforcement:[
					{},
					{
						code:1,
						description:i18n.t('CIVICS.CONSTANTS.PROPERTY_OWNER')
					},
					{
						code:2,
						description:i18n.t('CIVICS.CONSTANTS.LICENSED_CONTACT')
					},
					{},
					{
						code:4,
						description:i18n.t('CIVICS.CONSTANTS.OTHER_CONTACT')
					}
				],
				planning:[
					{},
					{
						code:1,
						description:i18n.t('CIVICS.CONSTANTS.PROPERTY_OWNER')
					},
					{
						code:2,
						description:i18n.t('CIVICS.CONSTANTS.LICENSED_CONTACT')
					},
					{},
					{
						code:4,
						description:i18n.t('CIVICS.CONSTANTS.OTHER_CONTACT')
					}
				],
				project:[
					{},
					{
						code:1,
						description:i18n.t('CIVICS.CONSTANTS.PROPERTY_OWNER')
					},
					{
						code:2,
						description:i18n.t('CIVICS.CONSTANTS.LICENSED_CONTACT')
					},
					{},
					{
						code:4,
						description:i18n.t('CIVICS.CONSTANTS.OTHER_CONTACT')
					}
				],
				// tradelicense:[
				// 	{},
				// 	{
				// 		code:1,
				// 		description:i18n.t('CIVICS.CONSTANTS.OTHER_CONTACT')
				// 	},
				// 	{
				// 		code:2,
				// 		description:i18n.t('CIVICS.CONSTANTS.LICENSED_CONTACT')
				// 	},
				// 	{
				// 		code:3,
				// 		description:i18n.t('CIVICS.CONSTANTS.PROPERTY_OWNER')
				// 	}
				// ],
				tradelicense:[//NEW PER AMY
					{},
					{},
					{
						code:2,
						description:''//i18n.t('CIVICS.CONSTANTS.LICENSED_CONTACT')//don't show for tradelicense
					},
					{}
				],
				use:[
					{},
					{
						code:1,
						description:i18n.t('CIVICS.CONSTANTS.PROPERTY_OWNER')
					},
					{
						code:2,
						description:i18n.t('CIVICS.CONSTANTS.LICENSED_CONTACT')
					},
					{},
					{
						code:4,
						description:i18n.t('CIVICS.CONSTANTS.OTHER_CONTACT')
					}
				]
			}
		},
		PRE_DIRECTION: function(){
			return [{
				code:'N',
				description:i18n.t('CIVICS.CONSTANTS.NORTH')
			}, {
				code:'S',
				description:i18n.t('CIVICS.CONSTANTS.SOUTH')
			}, {
				code:'E',
				description:i18n.t('CIVICS.CONSTANTS.EAST')
			}, {
				code:'W',
				description:i18n.t('CIVICS.CONSTANTS.WEST')
			}]
		},
		RECORD_TYPES: function(){
			//Since these are used to load from the services, they should be hardcoded!
			return {
				servicerequest: 'ServiceRequest',
				building: 'Building',
				businesslicense: 'BusinessLicense',
				planning: 'Planning',
				use: 'Use',
				tradelicense: 'TradeLicense',
				project: 'Project',
				codeenforcement: 'CodeEnforcement'
			};
		},
		GLOBAL_RECORD_TYPES: function(){//instrumentType.toLowerCase() -> globalConfig attribute name
			return {
				servicerequest: 'serviceRequest',
				building: 'building',
				businesslicense: 'businessLicense',
				planning: 'planning',
				use: 'use',
				tradelicense: 'tradeLicense',
				project: 'project',
				codeenforcement: 'codeEnforcement'
			};
		},
		INSPECTION_STATE: function(){
			// 2016-09-26 PL:  These do not need to be localized, only used internally
			return {
				CLOSED: 'Closed',
				SCHEDULED: 'Scheduled',
				DATE_PENDING: 'Date Pending',
				DATE_NOT_REQUESTED: 'Date Not Requested'
			};
		},
		REVIEW_STATE: function(){
			// 2016-09-26 PL:  These do not need to be localized, only used internally
			return {
				CLOSED: 'Closed',
				ASSIGNED: 'Assigned',
				NOT_ASSIGNED: 'Not Assigned'
			};
		},
		BUSINESS_TYPES: function(){
			return [
				{
					code: 'Corporation',
					description: i18n.t('CIVICS.CONSTANTS.CORPORATION')
				},
				{
					code: 'LLC',
					description: i18n.t('CIVICS.CONSTANTS.LLC')
				},
				{
					code: 'None',
					description: i18n.t('CIVICS.CONSTANTS.NONE')
				},
				{
					code: 'Other',
					description: i18n.t('CIVICS.CONSTANTS.OTHER')
				},
				{
					code: 'Partnership',
					description: i18n.t('CIVICS.CONSTANTS.PARTNERSHIP')
				},
				{
					code: 'SoleProprietor',
					description: i18n.t('CIVICS.CONSTANTS.SOLE_PROPRIETOR')
				}
			];
		},
		SCENARIO_STATUS:function(){
			return {
					Active:i18n.t('CIVICS.CONSTANTS.SCENARIO_STATUS.ACTIVE'),

					ApplicationPending:i18n.t('CIVICS.CONSTANTS.SCENARIO_STATUS.APPLICATION_PENDING'),

					QuestionsPending:i18n.t('CIVICS.CONSTANTS.SCENARIO_STATUS.QUESTIONS_PENDING'),

					ReadyToApply:i18n.t('CIVICS.CONSTANTS.SCENARIO_STATUS.READY_TO_APPLY')
				};
		},
		SITE_TYPE_FOR_APPLICATION_ASSOCIATION:{//when submitting an application with sites/associating sites with an application
			ADDRESS : 1,
			PARCEL : 2,
			PROPERTY : 3,//not used
			ASSET : 4,
		}
	}
});
